
    import './styles.scoped.css';
    export default {
  "selectable-item": "awsui_selectable-item_15o6u_z4t1q_3",
  "pad-bottom": "awsui_pad-bottom_15o6u_z4t1q_23",
  "has-background": "awsui_has-background_15o6u_z4t1q_32",
  "highlighted": "awsui_highlighted_15o6u_z4t1q_35",
  "selected": "awsui_selected_15o6u_z4t1q_35",
  "next-item-selected": "awsui_next-item-selected_15o6u_z4t1q_54",
  "is-keyboard": "awsui_is-keyboard_15o6u_z4t1q_62",
  "parent": "awsui_parent_15o6u_z4t1q_65",
  "child": "awsui_child_15o6u_z4t1q_71",
  "disabled": "awsui_disabled_15o6u_z4t1q_77",
  "virtual": "awsui_virtual_15o6u_z4t1q_83",
  "measure-strut": "awsui_measure-strut_15o6u_z4t1q_94",
  "measure-strut-first": "awsui_measure-strut-first_15o6u_z4t1q_103"
};
  